import * as light from "./palettes/light.module.scss";

export const THEME_PRESETS = {
  light: light,
};
